import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Image, Row, Table } from 'react-bootstrap'
import ImgCheckbox from '../../../../images/checkbox.svg'
import styled from 'styled-components'
import { useSearchParams } from 'react-router-dom'
import {
  getChecklistITAssetResignDetailAPI,
  getChecklistResignDetailITAPI,
  putChecklistResignIT2API,
  putChecklistResignITAPI,
  putChecklistResignITAssetAPI,
  putChecklistResignITDeatilAPI
} from '../../../../services/checklist'
import SwalCustom from '../../../../alert/swal-custom'
import { TXTSUCCESS } from '../../../../Constants'
import Error_false from '../../../error/error-false'
import moment from 'moment'
import { BsCheck2, BsCheckCircleFill, BsCircleFill } from 'react-icons/bs'
import { Checkbox, Input } from 'antd'
import Swal from 'sweetalert2'

export default function ResignsCheckListIT() {
  let [searchParams, setSearchParams] = useSearchParams()
  const clrNo = searchParams.get('id')
  const [comment, setComment] = useState('')
  const [selectId, setSelectId] = useState(0)
  const [isSave, setIsSave] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [detail_1, setDetail_1] = useState([])
  const [detail_2, setDetail_2] = useState([])
  const [detail_3, setDetail_3] = useState([])
  const [detail_4, setDetail_4] = useState([])
  const [detail_5, setDetail_5] = useState([])
  const [approve, setApprove] = useState()
  const [approveSup, setApproveSup] = useState()
  const [dataStep, setDataStep] = useState([])
  const [isSubmit, setIsSubmit] = useState(false)
  const [isUsername, setIsUsername] = useState(true)
  const [checking, setChecking] = useState(false)
  const [asset, setAsset] = useState([])

  useEffect(() => {
    getDataIT()
    fnGetDetail()
  }, [clrNo])

  const [data, setData] = useState()
  const [dataITAsset, setDataITAsset] = useState()

  const dataIT = [
    {
      id: 1,
      label: 'ดำเนินการครบถ้วน'
    },
    {
      id: 2,
      label: 'ค้างบางรายการ'
    }
  ]
  const [createDate, setCreateDate] = useState([])

  const getDataIT = async () => {
    // try {
    setIsLoading(true)

    const resp = await getChecklistResignDetailITAPI({ clrNo })
    setIsLoading(false)
    if (!resp) return
    if (resp.status) {
      setCreateDate(resp.result.insert_date)

      setData(resp.result[0])
      setAsset(resp.result.asset)
      setApprove(resp.result.approve)
      setChecking(resp.result.approve?.is_confirm)
      setApproveSup(resp.result?.approve_it_sup)
      setDataStep(resp.result.result)
      setDetail_1(
        resp.result.result.length > 0 ? resp.result.result[0].groups : []
      )
      setDetail_2(
        resp.result.result.length > 1 ? resp.result.result[1].groups : []
      )
      setDetail_3(
        resp.result.result.length > 2 ? resp.result.result[2].groups : []
      )
      setDetail_4(
        resp.result.result.length > 3 ? resp.result.result[3].groups : []
      )
      setDetail_5(
        resp.result.result.length > 4 ? resp.result.result[4].groups : []
      )
    } else {
      setDataStep([])
      setDetail_1([])
      setDetail_2([])
      setDetail_3([])
      setDetail_4([])
      setDetail_5([])
    }
  }

  //การเตรียมความพร้อมอุปกรณ์ IT
  const fnConfirmDetail_1 = (data) => {
    const body = {
      equipId: dataStep[0].equip_it_group_id,
      equips: [{ id: data.id, detail: data.detail ?? '' }]
    }
    if (data.is_detail === 1 && !data.detail) {
      SwalCustom({
        title: 'ตรวจสอบข้อมูล',
        text: 'โปรดกรอกข้อมูลให้ครบถ้วนก่อนกดยืนยัน',
        confirmButtonColor: '#f9af29',
        showConfirmButton: true
      })
    } else {
      fnSave(body)
    }
  }

  // เปิดสิทธิ์การใช้งานแอปพลิเคชัน
  const fnInputDetail_1 = (event, id) => {
    const { value, checked } = event.target
    if (value || checked) {
      setDetail_1((prev) => {
        const newData = prev.filter((item) => item.id === id)
        return [
          ...[
            {
              ...newData[0],
              is_check: 1,
              detail: value
            }
          ],
          ...prev.filter((item) => item.id !== id)
        ]
      })
    } else {
      setDetail_1((prev) => {
        const newData = prev.filter((item) => item.id === id)
        return [
          ...[
            {
              ...newData[0],
              is_check: 0,
              detail: value
            }
          ],
          ...prev.filter((item) => item.id !== id)
        ]
      })
    }
  }

  //ตั้งค่าเครื่องคอมพิวเตอร์
  const fnConfirmDetail_2 = (data) => {
    const body = {
      equipId: dataStep[1].equip_it_group_id,
      equips: [{ id: data.id, detail: data.detail ?? '' }]
    }
    if (data.is_detail === 1 && !data.detail) {
      SwalCustom({
        title: 'ตรวจสอบข้อมูล',
        text: 'โปรดกรอกข้อมูลให้ครบถ้วนก่อนกดยืนยัน',
        confirmButtonColor: '#f9af29',
        showConfirmButton: true
      })
    } else {
      fnSave(body)
    }
  }

  const fnInputDetail_2 = (event, id) => {
    const { value, checked } = event.target
    if (value || checked) {
      setDetail_2((prev) => {
        const newData = prev.filter((item) => item.id === id)
        return [
          ...[
            {
              ...newData[0],
              is_check: 1,
              detail: value
            }
          ],
          ...prev.filter((item) => item.id !== id)
        ]
      })
    } else {
      setDetail_2((prev) => {
        const newData = prev.filter((item) => item.id === id)
        return [
          ...[
            {
              ...newData[0],
              is_check: 0,
              detail: value
            }
          ],
          ...prev.filter((item) => item.id !== id)
        ]
      })
    }
  }

  //ซอฟต์แวร์
  const handleCheckList_3 = (event, id) => {
    const { checked } = event.target
    if (checked) {
      setDetail_3((prev) => {
        const newData = prev.filter((item) => item.id === id)
        return [
          ...[
            {
              ...newData[0],
              is_check: 1,
              detail: ''
            }
          ],
          ...prev.filter((item) => item.id !== id)
        ]
      })
    } else {
      setDetail_3((prev) => {
        const newData = prev.filter((item) => item.id === id)
        return [
          ...[
            {
              ...newData[0],
              is_check: 0,
              detail: ''
            }
          ],
          ...prev.filter((item) => item.id !== id)
        ]
      })
    }
  }

  //software
  const fnConfirmDetail_3 = () => {
    const isCheck = detail_3.filter((d) => d.is_check === 1)
    const body = {
      equipId: dataStep[2].equip_it_group_id,
      equips: isCheck
    }
    fnSave(body)
  }

  // การเตรียมความพร้อมด้านการใช้งานระบบ IT

  const handleCheckList_4 = (event, id) => {
    const { checked } = event.target

    if (checked) {
      setDetail_4((prev) => {
        const newData = prev.filter((item) => item.id === id)
        return [
          ...[
            {
              ...newData[0],
              is_check: 1,
              detail: ''
            }
          ],
          ...prev.filter((item) => item.id !== id)
        ]
      })
    } else {
      setDetail_4((prev) => {
        const newData = prev.filter((item) => item.id === id)
        return [
          ...[
            {
              ...newData[0],
              is_check: 0,
              detail: ''
            }
          ],
          ...prev.filter((item) => item.id !== id)
        ]
      })
    }
  }

  const fnConfirmDetail_4 = () => {
    const isCheck = detail_4.filter((d) => d.is_check === 1)
    const body = {
      equipId: dataStep[3].equip_it_group_id,
      equips: isCheck
    }
    fnSave(body)
  }

  const handleCheckList_5 = (event, id) => {
    const { checked } = event.target

    if (checked) {
      setDetail_5((prev) => {
        const newData = prev.filter((item) => item.id === id)
        return [
          ...[
            {
              ...newData[0],
              is_check: 1,
              detail: ''
            }
          ],
          ...prev.filter((item) => item.id !== id)
        ]
      })
    } else {
      setDetail_5((prev) => {
        const newData = prev.filter((item) => item.id === id)
        return [
          ...[
            {
              ...newData[0],
              is_check: 0,
              detail: ''
            }
          ],
          ...prev.filter((item) => item.id !== id)
        ]
      })
    }
  }

  const fnConfirmDetail_5 = () => {
    const isCheck = detail_5.filter((d) => d.is_check === 1)
    const body = {
      equipId: dataStep[4].equip_it_group_id,
      equips: isCheck
    }
    fnSave(body)
  }

  const fnSave2 = async () => {
    setIsSave(true)
    setIsLoading(true)

    const param = { clrNo }
    const body = {
      isConfirm: selectId === 1 ? true : false,
      description: selectId === 2 ? comment : ''
    }
    const resp = await putChecklistResignITAPI(param, body)
    setIsLoading(false)
    setIsSave(false)
    if (!resp) return
    if (resp.status) {
      SwalCustom({
        title: 'Success!',
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        getDataIT()
      })
    } else {
      Error_false(resp)
    }
  }

  const fnSave = async (body) => {
    setIsSave(true)
    setIsLoading(true)

    const param = { clrNo }
    const resp = await putChecklistResignITDeatilAPI(param, body)
    setIsLoading(false)
    setIsSave(false)
    if (!resp) return
    if (resp.status) {
      SwalCustom({
        title: 'Success!',
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        getDataIT()
      })
    } else {
      if (body?.equipId === 4 || body?.equipId === 5) {
        Swal.fire({
          icon: 'error',
          title: 'โปรดเลือกข้อมูล!',
          text: 'กรุณาลองใหม่อีกครั้ง',
          timer: 1500,
          showConfirmButton: false
        })
      } else {
        Error_false(resp)
      }
    }
  }

  const onSubmit = async () => {
    setIsSave(true)
    setIsLoading(true)

    const param = { clrNo }
    const resp = await putChecklistResignIT2API(param)
    setIsLoading(false)
    setIsSave(false)
    if (!resp) return
    if (resp.status) {
      SwalCustom({
        title: 'Success!',
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        getDataIT()
      })
    } else {
      Error_false(resp)
    }
  }

  const dataITAssets = [
    {
      id: 1,
      label: 'รับคืนครบถ้วน'
    },
    {
      id: 2,
      label: 'รับคืนไม่ครบหรือสภาพเสียหาย'
    },
    {
      id: 3,
      label: 'ไม่ใช้งานคอมพิวเตอร์'
    }
  ]
  // GET: IT Assets
  const fnGetDetail = async () => {
    const body = { clrNo }
    const resp = await getChecklistITAssetResignDetailAPI(body)
    setIsLoading(false)
    if (!resp) return
    if (resp.status) {
      setDataITAsset(resp.result)
    } else {
      Error_false(resp)
    }
  }
  // PUT: Asset IT
  const fnSaveAssetIT = async () => {
    const param = { clrNo }
    const body = {
      isConfirm:
        selectId === 1
          ? 1 //รับคืนครบถ้วน
          : selectId === 2
            ? 0 //รับคืนไม่ครบหรือสภาพเสียหาย
            : selectId === 3
              ? 2 //ไม่มีคอมพิวเตอร์
              : undefined,
      description: selectId === 2 ? comment : ''
    }
    SwalCustom({
      title: 'Are you sure?',
      text: 'Do you want to create new?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#2C5DFE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!'
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true)
        createAssetIT(param, body)
      }
    })
  }
  const createAssetIT = async (param, body) => {
    setIsSave(true)
    const resp = await putChecklistResignITAssetAPI(param, body)
    setIsLoading(false)
    setIsSave(false)

    if (!resp) return

    if (resp.status) {
      SwalCustom({
        title: 'Success!',
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        fnGetDetail()
      })
    } else {
      Error_false(resp)
    }
  }
  return (
    <Row>
      <Col xl={12}>
        <div className="mt-4 mb-3">
          <span className="fw-bold me-2">เลขเอกสาร: </span>
          <span className="">{clrNo}</span>{' '}
          <span className="fw-light me-2">
            {createDate ? moment(createDate).format('DD/MM/YYYY HH:mm') : ''}
          </span>
        </div>
        <div className=" me-4">
          <div className="fw-bold mb-3">รายการทรัพย์สิน</div>
          <Table bordered size="sm" className="mb-5">
            <thead className="bg-hrms">
              <tr>
                <th className="fw-light ">#</th>
                <th className="fw-light">Asset Tag</th>
                <th className="fw-light">Name</th>

                <th className="fw-light">Category</th>
                <th className="fw-light">Serial</th>
              </tr>
            </thead>
            <tbody>
              {asset && asset.length > 0 ? (
                asset.map((d, i) => (
                  <tr className="fw-light small" key={`tr-${i}`}>
                    <td>{i + 1}</td>
                    <td>{d?.asset_tag}</td>
                    <td>{d?.name}</td>
                    <td>{d.category}</td>
                    <td>{d.serial}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} className="text-center">
                    - No data -
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>

        <div className="col-12">
          <div className="mb-3 ">
            <span className="fw-bold ">
              ตรวจสอบและเก็บคืนทรัพย์สินบริษัทฯ
            </span>{' '}
          </div>
          <CheckboxRadioCustom className="fw-light">
            {dataITAssets.map((d, i) => (
              <div className="form-check mb-3 " key={`${d}-${i}`}>
                {dataITAsset && dataITAsset.confirm_date5 === null && (
                  <input
                    checked={d.id === selectId}
                    name={`description1`}
                    type="radio"
                    id={`inline-checkbox-${i}`}
                    className="form-check-input"
                    onChange={() => setSelectId(d.id)}
                  />
                )}
                {dataITAsset && dataITAsset.confirm_date5 && (
                  <>
                    {/* true false 2 */}
                    <label className="mb-2 fw-light">
                      {(dataITAsset?.is_confirm5 === 1 && d.id === 1) ||
                      (dataITAsset?.is_confirm5 === 0 && d.id === 2) ||
                      (dataITAsset?.is_confirm5 === 2 && d.id === 3) ? (
                        <BsCheckCircleFill
                          className="me-2"
                          size={20}
                          style={{ color: '#408bff' }}
                        />
                      ) : (
                        dataITAsset &&
                        dataITAsset.confirm_date5 && (
                          <BsCircleFill
                            className="me-2"
                            size={20}
                            style={{ color: '#bbbbbb' }}
                          />
                        )
                      )}
                      {d.label}
                    </label>
                    {d.id === 2 && (
                      <div
                        style={{
                          marginLeft: '35px',
                          maxWidth: '400px'
                        }}
                      >
                        <BoxName className="rounded-3">
                          {dataITAsset && dataITAsset?.description5}
                        </BoxName>
                      </div>
                    )}
                  </>
                )}

                {dataITAsset && dataITAsset.confirm_date5 === null && (
                  <div className="form-check-label">
                    <label htmlFor={`checkbox-radio-${i}`}>{d.label}</label>

                    {d.id === 2 && (
                      <div
                        style={{
                          marginLeft: '35px',
                          maxWidth: '400px'
                        }}
                      >
                        {selectId === 2 ? (
                          <Form.Control
                            as="textarea"
                            rows={3}
                            onChange={(e) => setComment(e.target.value)}
                          />
                        ) : (
                          <></>
                        )}
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))}
          </CheckboxRadioCustom>
        </div>
        <div className="col-12 d-flex justify-content-between">
          {dataITAsset && dataITAsset.is_confirm5 !== null ? (
            <Col xl={12} className="text-center">
              <Row>
                <Col>
                  <div className=" mt-5 font-small-2 d-flex justify-content-center">
                    <div style={{ width: 300 }}>
                      <div className="d-flex justify-content-center">
                        {dataITAsset && dataITAsset.confirm_detail5.url5 && (
                          <Image
                            width={250}
                            fluid
                            src={dataITAsset.confirm_detail5.url5}
                          />
                        )}
                      </div>
                      <div className="d-flex justify-content-center">
                        ลงชื่อ
                        <div
                          style={{
                            borderBottom: '1px dashed rgb(135, 135, 135)',
                            width: 200
                          }}
                        ></div>{' '}
                        ผู้ดำเนินการ
                      </div>
                      <div className="d-flex justify-content-center mt-3">
                        (
                        {dataITAsset &&
                          `${dataITAsset.confirm_detail5.title_th}${dataITAsset.confirm_detail5.name_th} ${dataITAsset.confirm_detail5.surname_th}`}
                        )
                      </div>
                      <div className="d-flex justify-content-center fw-light mt-1">
                        {dataITAsset && dataITAsset.confirm_detail5.position_th}
                      </div>
                      <div className="d-flex justify-content-center fw-light">
                        {dataITAsset &&
                          dataITAsset.confirm_date5 &&
                          moment(dataITAsset.confirm_date5).format(
                            'DD/MM/YYYY'
                          )}
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          ) : (
            <Col xl={12} className=" text-center">
              <div>
                <div className="d-flex justify-content-center">
                  {dataITAsset && dataITAsset.confirm_date5 !== null ? (
                    <Image
                      width={250}
                      fluid
                      src={dataITAsset?.confirm_detail5?.url}
                    />
                  ) : (
                    <Button
                      className="px-4"
                      disabled={isSave}
                      onClick={() => {
                        if (selectId !== 0) {
                          fnSaveAssetIT()
                        } else {
                          SwalCustom({
                            icon: 'warning',
                            title: 'โปรดเลือกข้อมูล!',
                            text: 'กรุณาลองใหม่อีกครั้ง',
                            confirmButtonColor: ''
                          })
                        }
                      }}
                    >
                      Confirm
                    </Button>
                  )}
                </div>
                <div className="d-flex justify-content-center small">
                  ลงชื่อ
                  <div
                    style={{
                      borderBottom: '1px dashed rgb(135, 135, 135)',
                      width: 200
                    }}
                  ></div>{' '}
                  ผู้ตรวจสอบ
                </div>
                <div className="d-flex justify-content-center mt-3 small">
                  (
                  {dataITAsset?.confirm_detail5 &&
                    `${
                      dataITAsset?.confirm_detail5?.title_th
                        ? dataITAsset?.confirm_detail5?.title_th
                        : '-'
                    }${
                      dataITAsset?.confirm_detail5?.name_th
                        ? dataITAsset?.confirm_detail5?.name_th
                        : '-'
                    } ${
                      dataITAsset?.confirm_detail5?.surname_th
                        ? dataITAsset?.confirm_detail5?.surname_th
                        : '-'
                    }`}
                  )
                </div>
                <div className="d-flex justify-content-center small fw-light mt-1">
                  {dataITAsset?.confirm_detail5 &&
                    dataITAsset?.confirm_detail5?.position_th}
                </div>
                <div className="d-flex justify-content-center small fw-light">
                  {dataITAsset?.confirm_detail5 &&
                  dataITAsset?.confirm_detail5?.confirm_date3_2
                    ? moment(
                        dataITAsset?.confirm_detail5?.confirm_date3_2
                      ).format('DD/MM/YYYY')
                    : '-'}
                </div>
              </div>
            </Col>
          )}
        </div>

        <div className="fw-bold mb-2 mt-2">
          <span className="text-danger">ถอน </span>
          {dataStep?.length > 0 && dataStep[0]?.equip_it_group}
        </div>

        {detail_1.length > 0 &&
          detail_1
            .sort((a, b) => a.id - b.id)
            .map((d, i) => (
              <Row className="mb-3" key={i}>
                <Col md={5}>
                  <Checkbox.Group>
                    <CheckboxCustom className="fw-light">
                      {d?.is_detail === 1 ? (
                        <div
                          className="form-check mb-3 d-flex"
                          key={`${d}-${i}`}
                        >
                          <input
                            checked={d?.is_check === 1 ? true : false}
                            name={`detail_1-checkbox-${i}`}
                            id={`detail_1-checkbox-${i}`}
                            type="checkbox"
                            className="form-check-input"
                          />
                          <div className="form-check-label">
                            <label for={`detail_1-checkbox-${i}`}>
                              {d?.equip_it_name}
                            </label>
                            <div
                              style={{ marginLeft: '15px', maxWidth: '150px' }}
                            >
                              {approve ? (
                                <Form.Control
                                  name="ExtensionNumber"
                                  disabled={true}
                                  value={d.detail}
                                  readOnly
                                />
                              ) : (
                                <Form.Control
                                  name="ExtensionNumber"
                                  readOnly
                                  disabled={
                                    d?.is_check === 1 && d?.confirm_date
                                      ? true
                                      : false
                                  }
                                  value={d.detail}
                                  onChange={(e) => fnInputDetail_1(e, d?.id)}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      ) : (
                        <Form.Check
                          checked={d?.is_check === 0 ? false : true}
                          label={d?.equip_it_name}
                          name={`description1`}
                          type="checkbox"
                          className="mb-3 d-flex"
                        />
                      )}
                    </CheckboxCustom>
                  </Checkbox.Group>
                </Col>
                <Col md={7}>
                  <div className="d-flex" style={{ columnGap: '16px' }}>
                    {approve ? (
                      <></>
                    ) : (
                      <Button
                        size="sm"
                        style={{ minWidth: 110 }}
                        disabled={
                          d?.is_check === 1 && d?.confirm_date ? true : false
                        }
                        className="rounded-3"
                        onClick={() => {
                          fnConfirmDetail_1(d)
                        }}
                      >
                        <BsCheck2 size={18} className="me-1" /> Confirm
                      </Button>
                    )}
                    <BoxName className="rounded-3">
                      {d.name_th} {d.surname_th}{' '}
                      {d.confirm_date
                        ? moment(d.confirm_date).format('DD/MM/YYYY')
                        : ''}
                    </BoxName>
                  </div>
                </Col>
              </Row>
            ))}
      </Col>

      {asset.length > 0 ? (
        <Col xl={12}>
          <div className="fw-bold mb-2 ">
            <span className="text-danger">ถอน </span>
            {dataStep.length > 1 && dataStep[1]?.equip_it_group}
          </div>

          {detail_2.length > 0 &&
            detail_2
              .sort((a, b) => a.id - b.id)
              .map((d, i) => (
                <Row className="mb-3" key={`set-com${i}`}>
                  <Col md={5}>
                    <Checkbox.Group>
                      <CheckboxCustom className="fw-light">
                        {d.is_detail === 1 ? (
                          <div className="form-check mb-3" key={`${d}-${i}`}>
                            <input
                              checked={d.is_check === 1 ? true : false}
                              name={`description1`}
                              type="checkbox"
                              id={`inline-checkbox-${i}`}
                              className="form-check-input"
                            />
                            <div className="form-check-label">
                              <label htmlFor={`checkbox-radio-${i}`}>
                                {d.equip_it_name}
                              </label>
                              <div
                                style={{
                                  marginLeft: '35px',
                                  maxWidth: '150px'
                                }}
                              >
                                <Form.Control
                                  disabled={
                                    d.is_check === 1 && d.confirm_date
                                      ? true
                                      : false
                                  }
                                  readOnly
                                  name="ITAsset"
                                  value={d.detail}
                                  onChange={(e) => fnInputDetail_2(e, d.id)}
                                />
                              </div>
                            </div>
                          </div>
                        ) : (
                          <Form.Check
                            defaultChecked={d.is_check === 0 ? false : true}
                            checked={d?.is_check === 0 ? false : true}
                            label={d?.equip_it_name}
                            name={`description1`}
                            type="checkbox"
                            className="mb-3"
                          />
                        )}
                      </CheckboxCustom>
                    </Checkbox.Group>
                  </Col>

                  <Col md={7}>
                    <div className="d-flex" style={{ columnGap: '16px' }}>
                      {approve ? (
                        <></>
                      ) : (
                        <Button
                          size="sm"
                          style={{ minWidth: 120 }}
                          disabled={
                            d?.is_check === 1 && d?.confirm_date ? true : false
                          }
                          className="rounded-3"
                          onClick={() => fnConfirmDetail_2(d)}
                        >
                          <BsCheck2 size={18} className="me-1" /> Confirm
                        </Button>
                      )}
                      <BoxName className="rounded-3">
                        {' '}
                        {d?.name_th} {d?.surname_th}{' '}
                        {d?.confirm_date
                          ? moment(d?.confirm_date).format('DD/MM/YYYY')
                          : ''}
                      </BoxName>
                    </div>
                  </Col>
                </Row>
              ))}
        </Col>
      ) : (
        <></>
      )}

      {asset.length > 0 ? (
        <>
          <Col xl={12}>
            <div className="fw-bold mb-2 ">
              {' '}
              <span className="text-danger">ถอน </span>
              {dataStep.length > 2 && dataStep[2]?.equip_it_group}
            </div>
            <Checkbox.Group>
              <CheckboxCustom className="fw-light">
                {detail_3.length > 0 &&
                  detail_3
                    .sort((a, b) => a.id - b.id)
                    .map((d, i) => (
                      <>
                        {dataStep[2]?.approve?.confirm_by &&
                        dataStep[2]?.approve?.confirm_date ? (
                          <Form.Check
                            checked={d.is_check === 1 ? true : false}
                            key={`set-softwear${i}`}
                            label={d.equip_it_name}
                            name={`description`}
                            type="checkbox"
                            className="mb-3"
                            value={d.id}
                            onChange={(e) =>
                              !dataStep[2]?.approve?.confirm_by &&
                              !dataStep[2]?.approve?.confirm_date &&
                              handleCheckList_3(e, d.id)
                            }
                          />
                        ) : (
                          <Form.Check
                            checked={d.is_check === 1 ? true : null}
                            key={`set-softwear${i}`}
                            label={d.equip_it_name}
                            name={`description`}
                            type="checkbox"
                            className="mb-3"
                            value={d.id}
                            onChange={(e) =>
                              !dataStep[2]?.approve?.confirm_by &&
                              !dataStep[2]?.approve?.confirm_date &&
                              handleCheckList_3(e, d.id)
                            }
                          />
                        )}
                      </>
                    ))}
              </CheckboxCustom>
            </Checkbox.Group>
          </Col>

          <Col xl={12} className="text-center mt-5 mb-5 ">
            {dataStep.length > 2 &&
            dataStep[2]?.approve?.confirm_by &&
            dataStep[2]?.approve?.confirm_date ? (
              <div className=" mt-5 font-small-2 d-flex justify-content-center">
                <div style={{ width: 300 }}>
                  <div className="d-flex justify-content-center">
                    <Image width={250} fluid src={dataStep[2]?.approve?.url} />
                  </div>
                  <div className="d-flex justify-content-center">
                    ลงชื่อ
                    <div
                      style={{
                        borderBottom: '1px dashed rgb(135, 135, 135)',
                        width: 200
                      }}
                    ></div>{' '}
                    ผู้ดำเนินการ
                  </div>
                  <div className="d-flex justify-content-center mt-3">
                    ({dataStep[2]?.approve?.title_th}
                    {dataStep[2]?.approve?.name_th}{' '}
                    {dataStep[2]?.approve?.surname_th})
                  </div>
                  <div className="d-flex justify-content-center fw-light mt-1">
                    {dataStep[2]?.approve?.position_th}
                  </div>
                  <div className="d-flex justify-content-center fw-light">
                    {dataStep[2]?.approve?.confirm_date
                      ? moment(dataStep[2]?.approve?.confirm_date).format(
                          'DD/MM/YYYY'
                        )
                      : ''}
                  </div>
                </div>
              </div>
            ) : (
              <Button
                className="rounded-3"
                style={{ minWidth: 150 }}
                onClick={fnConfirmDetail_3}
              >
                <BsCheck2 size={18} className="me-1" /> Confirm
              </Button>
            )}
          </Col>
        </>
      ) : (
        <></>
      )}
      <Col xl={12}>
        <div className="fw-bold mb-2 ">
          <span className="text-danger">ถอน</span>
          {dataStep?.length > 3 && dataStep[3]?.equip_it_group}
        </div>

        <Checkbox.Group>
          <CheckboxCustom className="fw-light">
            {detail_4.length > 0 &&
              detail_4
                .sort((a, b) => a.id - b.id)
                .map((d, i) => (
                  <>
                    <div className="form-check mb-3" key={d + i}>
                      {!dataStep[3]?.approve?.confirm_by &&
                      !dataStep[3]?.approve?.confirm_date ? (
                        // <></>
                        <input
                          // readOnly
                          checked={d.is_check === 1 ? true : null}
                          name={`group4`}
                          type="checkbox"
                          id={`inline-group4-${i}`}
                          className={`form-check-input`}
                          onChange={(e) =>
                            !dataStep[3]?.approve?.confirm_by &&
                            !dataStep[3]?.approve?.confirm_date &&
                            handleCheckList_4(e, d.id)
                          }
                        />
                      ) : (
                        <>
                          <Form.Check
                            checked={d.is_check === 1 ? true : false}
                            name={`group4`}
                            type="checkbox"
                            className="mb-3"
                            onChange={(e) =>
                              !dataStep[3]?.approve?.confirm_by &&
                              !dataStep[3]?.approve?.confirm_date
                            }
                          />
                        </>
                      )}
                      <div className="form-check-label">
                        <label htmlFor={`inline-group4-${i}`}>
                          {d.equip_it_name}
                        </label>

                        {d.is_detail ? (
                          <div
                            style={{ marginLeft: '35px', minWidth: '300px' }}
                          >
                            <Form.Control
                              className="border-0"
                              disabled
                              defaultValue={d?.detail || '-'}
                            />
                          </div>
                        ) : null}

                        {d.id === 15 && !isUsername && (
                          <div
                            style={{
                              marginLeft: '35px',
                              fontSize: '13px',
                              color: '#e74747'
                            }}
                          >
                            ชื่อผู้ใช้นี้มีในระบบแล้ว
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                ))}
          </CheckboxCustom>
        </Checkbox.Group>
      </Col>
      <Col xl={12} className="text-center mt-5 mb-5">
        {dataStep?.length > 3 &&
        dataStep[3]?.approve?.confirm_by &&
        dataStep[3]?.approve?.confirm_date ? (
          <div className=" mt-5 font-small-2 d-flex justify-content-center">
            <div style={{ width: 300 }}>
              <div className="d-flex justify-content-center">
                <Image width={250} fluid src={dataStep[3]?.approve?.url} />
              </div>
              <div className="d-flex justify-content-center">
                ลงชื่อ
                <div
                  style={{
                    borderBottom: '1px dashed rgb(135, 135, 135)',
                    width: 200
                  }}
                ></div>{' '}
                ผู้ดำเนินการ
              </div>
              <div className="d-flex justify-content-center mt-3">
                ({dataStep[3]?.approve?.title_th}
                {dataStep[3]?.approve?.name_th}{' '}
                {dataStep[3]?.approve?.surname_th})
              </div>
              <div className="d-flex justify-content-center fw-light mt-1">
                {dataStep[3]?.approve?.position_th}
              </div>
              <div className="d-flex justify-content-center fw-light">
                {dataStep[3]?.approve?.confirm_date
                  ? moment(dataStep[3]?.approve?.confirm_date).format(
                      'DD/MM/YYYY'
                    )
                  : ''}
              </div>
            </div>
          </div>
        ) : (
          <Button
            className="rounded-3"
            style={{ minWidth: 150 }}
            onClick={fnConfirmDetail_4}
          >
            <BsCheck2 size={18} className="me-1" /> Confirm
          </Button>
        )}
      </Col>
      <Col xl={12}>
        <div className="fw-bold mb-2 ">
          {' '}
          <span className="text-danger">ถอน </span>
          {dataStep.length > 4 && dataStep[4]?.equip_it_group}
        </div>

        <Checkbox.Group>
          <CheckboxCustom className="fw-light">
            {detail_5.length > 0 &&
              detail_5
                .sort((a, b) => a.id - b.id)
                .map((d, i) => (
                  <div className="form-check mb-3" key={d + i}>
                    <input
                      name={`group5`}
                      type="checkbox"
                      checked={d.is_check === 1 ? true : false}
                      id={`inline-checkbox-${i}`}
                      className="form-check-input"
                      onChange={(e) =>
                        !dataStep[4]?.approve?.confirm_by &&
                        !dataStep[4]?.approve?.confirm_date &&
                        handleCheckList_5(e, d.id)
                      }
                    />
                    <label htmlFor={`checkbox-radio-${i}`}>
                      {d?.equip_it_name}
                    </label>
                  </div>
                ))}
          </CheckboxCustom>
        </Checkbox.Group>

        {/* Button Confirm */}

        {dataStep.length > 4 &&
        dataStep[4]?.approve?.confirm_by &&
        dataStep[4]?.approve?.confirm_date ? (
          <div className=" mt-5 font-small-2 d-flex justify-content-center">
            <div style={{ width: 300 }}>
              <div className="d-flex justify-content-center">
                <Image width={250} fluid src={dataStep[4]?.approve?.url} />
              </div>
              <div className="d-flex justify-content-center">
                ลงชื่อ
                <div
                  style={{
                    borderBottom: '1px dashed rgb(135, 135, 135)',
                    width: 200
                  }}
                ></div>{' '}
                ผู้ดำเนินการ
              </div>
              <div className="d-flex justify-content-center mt-3">
                ({dataStep[4]?.approve?.title_th}
                {dataStep[4]?.approve?.name_th}{' '}
                {dataStep[4]?.approve?.surname_th})
              </div>
              <div className="d-flex justify-content-center fw-light mt-1">
                {dataStep[4]?.approve?.position_th}
              </div>
              <div className="d-flex justify-content-center fw-light">
                {dataStep[4]?.approve?.confirm_date
                  ? moment(dataStep[4]?.approve?.confirm_date).format(
                      'DD/MM/YYYY'
                    )
                  : ''}
              </div>
            </div>
          </div>
        ) : (
          <div className="d-flex justify-content-center">
            <Button
              className="rounded-3"
              style={{ minWidth: 150 }}
              onClick={fnConfirmDetail_5}
            >
              <BsCheck2 size={18} className="me-1" /> Confirm
            </Button>
          </div>
        )}
      </Col>

      <Col xl={12}>
        <div className="mb-3 mt-5">
          <span className="fw-bold ">การตรวจสอบด้านระบบ IT</span>{' '}
          <span>
            (ระงับสิทธิการเข้าถึงข้อมูล บัตรพนักงาน, E-mail, ระบบ Access Control
            และระบบอื่น ๆ ที่เกี่ยวข้อง)
          </span>
        </div>
        {isLoading && <div className="preloader"></div>}
        <CheckboxRadioCustom className="fw-light">
          {approve === null
            ? dataIT.map((d, i) => (
                <div className="form-check mb-3" key={`${d}-${i}`}>
                  <input
                    checked={d.id === selectId}
                    name={`description1`}
                    type="radio"
                    id={`inline-checkbox-${i}`}
                    className="form-check-input"
                    onChange={() => setSelectId(d.id)}
                  />
                  <div className="form-check-label">
                    <label htmlFor={`checkbox-radio-${i}`}>{d.label}</label>

                    {i > 0 && (
                      <div
                        style={{
                          marginLeft: '35px',
                          maxWidth: '400px'
                        }}
                      >
                        {selectId === 2 ? (
                          <Form.Control
                            as="textarea"
                            rows={3}
                            onChange={(e) => setComment(e.target.value)}
                          />
                        ) : (
                          <></>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              ))
            : dataIT.map((d, i) => (
                <div className="form-check mb-3" key={`${d}-${i}`}>
                  <input
                    checked={
                      (d.id === 1 && checking === 1) ||
                      (d.id === 2 && checking === 0)
                    }
                    name={`description1`}
                    type="radio"
                    id={`inline-checkbox-${i}`}
                    className="form-check-input"
                    onChange={() => setSelectId(d.id)}
                  />
                  <div className="form-check-label">
                    <label htmlFor={`checkbox-radio-${i}`}>{d.label}</label>

                    {i > 0 && (
                      <div
                        style={{
                          marginLeft: '35px',
                          maxWidth: '400px'
                        }}
                      >
                        <Form.Control
                          as="textarea"
                          disabled
                          rows={3}
                          value={approve?.description ?? '-'}
                          onChange={(e) => setComment(e.target.value)}
                        />
                      </div>
                    )}
                  </div>
                </div>
              ))}
        </CheckboxRadioCustom>
      </Col>
      {approve !== null ? (
        <Col xl={12} className="text-center">
          <Row>
            <Col>
              <div className=" mt-5 font-small-2 d-flex justify-content-center">
                <div style={{ width: 300 }}>
                  <div className="d-flex justify-content-center">
                    {approve?.url && (
                      <Image width={250} fluid src={approve?.url} />
                    )}
                  </div>
                  <div className="d-flex justify-content-center">
                    ลงชื่อ
                    <div
                      style={{
                        borderBottom: '1px dashed rgb(135, 135, 135)',
                        width: 200
                      }}
                    ></div>{' '}
                    ผู้ดำเนินการ
                  </div>
                  <div className="d-flex justify-content-center mt-3">
                    (
                    {`${approve?.title_th}${approve?.name_th} ${approve?.surname_th}`}
                    )
                  </div>
                  <div className="d-flex justify-content-center fw-light mt-1">
                    {approve?.position_th}
                  </div>
                  <div className="d-flex justify-content-center fw-light">
                    {approve &&
                      approve?.confirm_date &&
                      moment(approve?.confirm_date).format('DD/MM/YYYY')}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      ) : (
        <Col xl={12} className="mt-5 text-center">
          <Button
            className="px-4"
            style={{ minWidth: 150 }}
            disabled={isSave}
            onClick={() => {
              if (selectId !== 0) {
                SwalCustom({
                  title: 'Are you sure?',
                  text: "You won't be able to revert this!",
                  showCancelButton: true,
                  confirmButtonColor: '#2C5DFE',

                  confirmButtonText: 'Submit'
                }).then((result) => {
                  if (result.isConfirmed) {
                    fnSave2()
                  }
                })
              } else {
                SwalCustom({
                  title: 'โปรดเลือกข้อมูล!',
                  text: 'กรุณาลองใหม่อีกครั้ง',
                  confirmButtonColor: ''
                })
              }
            }}
          >
            <BsCheck2 size={18} className="me-1" /> Confirm
          </Button>
        </Col>
      )}
      {asset.length > 0 ? (
        <div className=" mt-5 font-small-2 d-flex justify-content-center">
          {dataStep[0]?.groups[0]?.confirm_date &&
          dataStep[0]?.groups[1]?.confirm_date &&
          (dataStep[1]?.groups[0]?.is_check === 1 ||
            dataStep[1]?.groups[1]?.is_check === 1 ||
            dataStep[1]?.groups[2]?.is_check === 1 ||
            dataStep[1]?.groups[3]?.is_check === 1 ||
            dataStep[1]?.groups[4]?.is_check === 1) &&
          (dataStep[2]?.groups[0]?.is_check === 1 ||
            dataStep[2]?.groups[1]?.is_check === 1 ||
            dataStep[2]?.groups[2]?.is_check === 1 ||
            dataStep[2]?.groups[3]?.is_check === 1 ||
            dataStep[2]?.groups[4]?.is_check === 1 ||
            dataStep[2]?.groups[5]?.is_check === 1 ||
            dataStep[2]?.groups[6]?.is_check === 1 ||
            dataStep[2]?.groups[7]?.is_check === 1 ||
            dataStep[2]?.groups[8]?.is_check === 1) &&
          (dataStep[3]?.groups[0]?.is_check === 1 ||
            dataStep[3]?.groups[1]?.is_check === 1 ||
            dataStep[3]?.groups[2]?.is_check === 1 ||
            dataStep[3]?.groups[3]?.is_check === 1 ||
            dataStep[3]?.groups[4]?.is_check === 1) &&
          dataStep[4]?.groups[0]?.is_check === 1 &&
          dataStep[4]?.groups[1]?.is_check === 1 ? (
            <div style={{ width: 300 }}>
              {approveSup?.confirm_date ? (
                <div className="d-flex justify-content-center">
                  <Image width={250} fluid src={approveSup.url} />
                </div>
              ) : (
                <Col xl={12} className="mt-5 text-center">
                  <Button
                    className="px-5 rounded-3 "
                    disabled={isSubmit}
                    onClick={onSubmit}
                    size="sm"
                  >
                    {isSubmit ? 'Submitting...' : 'Submit'}
                  </Button>
                </Col>
              )}
              <div className="d-flex justify-content-center">
                ลงชื่อ
                <div
                  style={{
                    borderBottom: '1px dashed rgb(135, 135, 135)',
                    width: 200
                  }}
                ></div>{' '}
                ผู้ตรวจสอบ
              </div>
              <div className="d-flex justify-content-center mt-3">
                ({approveSup?.title_th}
                {approveSup?.name_th} {approveSup?.surname_th})
              </div>
              <div className="d-flex justify-content-center fw-light mt-1">
                {approveSup?.position_th}
              </div>
              <div className="d-flex justify-content-center fw-light mb-4">
                {approveSup?.confirm_date
                  ? moment(approveSup?.confirm_date).format('DD/MM/YYYY')
                  : '-'}
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      ) : (
        <div className=" mt-5 font-small-2 d-flex justify-content-center">
          {dataStep[0]?.groups[0]?.confirm_date &&
          dataStep[0]?.groups[1]?.confirm_date &&
          (dataStep[3]?.groups[0]?.is_check === 1 ||
            dataStep[3]?.groups[1]?.is_check === 1 ||
            dataStep[3]?.groups[2]?.is_check === 1 ||
            dataStep[3]?.groups[3]?.is_check === 1 ||
            dataStep[3]?.groups[4]?.is_check === 1) &&
          dataStep[4]?.groups[1]?.is_check === 1 &&
          dataStep[4]?.groups[1]?.is_check === 1 ? (
            <div style={{ width: 300 }}>
              {approveSup?.confirm_date ? (
                <div className="d-flex justify-content-center">
                  <Image width={250} fluid src={approveSup.url} />
                </div>
              ) : (
                <Col xl={12} className="mt-5 text-center">
                  <Button
                    className="px-5 rounded-3 "
                    disabled={isSubmit}
                    onClick={onSubmit}
                    size="sm"
                  >
                    {isSubmit ? 'Submitting...' : 'Submit'}
                  </Button>
                </Col>
              )}
              <div className="d-flex justify-content-center">
                ลงชื่อ
                <div
                  style={{
                    borderBottom: '1px dashed rgb(135, 135, 135)',
                    width: 200
                  }}
                ></div>{' '}
                ผู้ตรวจสอบ
              </div>
              <div className="d-flex justify-content-center mt-3">
                ({approveSup?.title_th}
                {approveSup?.name_th} {approveSup?.surname_th})
              </div>
              <div className="d-flex justify-content-center fw-light mt-1">
                {approveSup?.position_th}
              </div>
              <div className="d-flex justify-content-center fw-light mb-4">
                {approveSup?.confirm_date
                  ? moment(approveSup?.confirm_date).format('DD/MM/YYYY')
                  : '-'}
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      )}
    </Row>
  )
}

const CheckboxRadioCustom = styled.div`
  .form-check-inline {
    display: inline-block;
    margin-right: 3px;
  }

  .form-check-input[type='radio'] {
    margin-top: auto !important;
    margin-bottom: auto !important;
    border-radius: 1rem;
    background-image: url(${ImgCheckbox}) !important;
  }
  .form-check-input:checked {
    background-color: #2c5dfe !important;
  }
  .form-check-input {
    width: 1.5em;
    height: 1.5em;
    border: 1px solid #2c5dfe;
  }
  label {
    margin: 0em 0em 0em 1em;
  }
  .form-check .form-check-input {
    float: left;
    margin-left: 0em;
  }
`

const CheckboxCustom = styled.div`
  .form-check-inline {
    display: inline-block;
    margin-right: 3px;
  }

  .form-check-input[type='radio'] {
    margin-top: auto !important;
    margin-bottom: auto !important;
    border-radius: 4px;
    background-image: url(${ImgCheckbox}) !important;
  }
  .form-check-input:checked {
    background-color: 'var(--comp-badge-color-background-primary)' !important;
  }
  .form-check-input {
    width: 1.5em;
    height: 1.5em;
    border: 1px solid 'var(--comp-badge-color-background-primary)';
  }
  label {
    margin: 0em 0em 0em 1em;
  }
  .form-check .form-check-input {
    float: left;
    margin-left: 0em;
    margin-top: 0em;
  }
`
const BoxName = styled.div`
  font-size: 13px;
  min-width: 300px;
  background-color: #e3e3e3;
  border: 1px solid #e6e6e6;
  opacity: 0.5;
  height: 35px;
  padding: 0.375rem 0.75rem;
`
